<template>
    <div>
        <div class="page-block__overview-link">
            <customer-router-link
                :to="{ name: 'domainOverview', params: { domain: domain } }"
                class="link-no-decoration | u-flex-center"
            >
                <svg width="16" viewBox="0 0 32 32" class="u-margin-right-inline">
                    <use xlink:href="../assets/icomoon/SVG/icons.svg#arrow-right"></use>
                </svg>
                <strong>{{ trans('page.services.back-to') }} {{ domain }}</strong>
            </customer-router-link>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        domain: {
            type: String,
            required: true
        }
    }
};
</script>
